<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            path: '/dashboard',
            icon: 'ni ni-tv-2 text-primary',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Inquiries',
            path: '/inquiries',
            icon: 'ni ni-chat-round text-primary',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Accounts',
            path: '/accounts',
            icon: 'ni ni-circle-08 text-primary',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Churches',
            path: '/churches',
            icon: 'ni ni-building text-primary',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Members',
            path: '/members',
            icon: 'ni ni-single-02 text-primary',
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>

    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import { FadeTransition } from "vue2-transitions";
import _ from "lodash";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
  },
  computed: {
    currEmail() {
      return localStorage.getItem("email");
    },
  },
  mounted() {
    this.initScrollbar();

    // if a not authenticated user tries to access a page that requires authentication
    if (_.isNull(this.currEmail) || _.isEmpty(this.currEmail)) {
      this.redirectToLogin();
    }
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    redirectToLogin() {
      this.$toaster.warning("You are not allowed to access this page. Login to proceed.");

      // redirect to login page
      this.$router.push("/login");
    },
  },
};
</script>
<style lang="scss"></style>
